<ng-container *ngIf="hasItems();else noItems">
    <virtual-scroller #scroll
                      [items]="items.items"
                      (vsEnd)="onEnd($event)">
        <div class="item" *ngFor="let lift of scroll.viewPortItems" (click)="onSelectLiftClick(lift)"
             (contextmenu)="onLiftContextMenu($event, lift)">
            <i class="left-icon material-icons">view_list</i>
            <p class="center"> {{ lift.name }}</p>
            <i class="right-icon material-icons">chevron_right</i>
        </div>
    </virtual-scroller>
</ng-container>

<app-context-menu #liftContextMenu [contextMenuItems]="contextMenuItems"></app-context-menu>

<ng-template #noItems>
    <span>{{ 'admin.lifts.notifications.noLiftsCreated' | translate }}</span>
</ng-template>
